import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  transform(value: number) {
    if (value == null || value < 0) {
      return '00h 00min';
    }

    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    const paddedMinutes = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}h ${paddedMinutes}min`;
  }
}
